import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AdminTokens from './components/AdminTokens';
import ApiKeys from './components/ApiKeys';
import Dashboard from './components/Dashboard';
import DataViews from './components/DataViews/DataViews';
import GenerateWorkflows from './components/GenerateWorkflows';
import Login from './components/Login';
import LoginLayout from './components/LoginLayout';
import MainLayout from './components/MainLayout';
import NewWorkflow from './components/NewWorkflow/NewWorkflow';
import Page404 from "./components/Page404";
import PrivateRoute from './components/PrivateRoute';
import WorkflowHistory from "./components/WorkflowHistory/WorkflowHistory";
import Workflows from './components/Workflows';
import NotificationSettings from './components/NotificationSettings';

const RoutesContainer: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginLayout><Login /></LoginLayout>} />
      <Route path="/" element={<PrivateRoute />}>
        <Route path="/" element={<MainLayout />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="generateWorkflows" element={<GenerateWorkflows />} />
          <Route path="myWorkflows" element={<Workflows />} />
          <Route path="apiKeys" element={<ApiKeys />} />
          <Route path="/workflow/history/:workflowId" element={<WorkflowHistory />} />
          <Route path="/workflow/setup/:workflowId" element={<NewWorkflow />} />
          <Route path="/workflow/dataViews/:workflowId" element={<DataViews />} />
          <Route path="/admin/tokens" element={<AdminTokens />} />
          <Route path="/settings/notifications" element={<NotificationSettings />} />
          <Route path="/" element={<Dashboard />} />
        </Route>
      </Route>
      <Route path="*" element={<Page404 />} />
    </Routes>
  );
}

export default RoutesContainer;
